export enum LedgerSource {
  /** 开票详情 */
  APPLY_DETAIL,
  /** 合同管理 */
  CONTACT,
};